import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Status pill — the prototype `Pill({ tone, dot })` (screens_settings.jsx).
 * The one status-pill vocabulary used across Settings (role badges, health,
 * invoice status, usage %, constitution `enforcedBy`).
 */
export type PillTone =
  | 'primary' | 'info' | 'accent' | 'warning' | 'success' | 'danger' | 'neutral';

const TONE: Record<PillTone, string> = {
  primary: 'bg-cs-primary-500/15 text-cs-primary-400',
  info:    'bg-cs-info-bg text-cs-info-400',
  accent:  'bg-cs-accent-500/15 text-cs-accent-400',
  warning: 'bg-cs-warning-bg text-cs-warning-400',
  success: 'bg-cs-success-bg text-cs-success-400',
  danger:  'bg-cs-error-bg text-cs-error-400',
  neutral: 'bg-cs-surface-raised text-cs-text-muted',
};

export function Pill({
  tone = 'neutral',
  dot = false,
  className,
  children,
}: {
  tone?: PillTone;
  dot?: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONE[tone],
        className,
      )}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />}
      {children}
    </span>
  );
}
